<template>
  <div
    id="login-modal"
    class="fixed z-50 inset-0 overflow-y-auto"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div
        class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        aria-hidden="true"
        @click="hide"
      />

      <span
        class="hidden sm:inline-block sm:align-middle sm:h-screen"
        aria-hidden="true"
      >&#8203;</span>

      <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm  sm:p-6">
        <div class="absolute top-0 right-0 pt-4 pr-4">
          <button
            type="button"
            class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            @click="hide"
          >
            <span class="sr-only">Close</span>
            <i class="fal fa-times text-2xl" />
          </button>
        </div>

        <div class="text-left">
          <div class="font-bold text-lg mb-3">
            Ga verder met:
          </div>

          <div class="flex flex-flex-row items-center justify-center space-x-2 text-center font-bold text-lg">
            <a
              :href="route('frontend.auth.google')"
              class="border border-gray-300 rounded px-4 py-3 w-1/2 bg-white hover:brightness-95 text-black"
              title="Login met Google"
            >
              <img
                class="h-8 mx-auto"
                src="/img/login-google.svg"
              >
            </a>

            <a
              :href="route('frontend.auth.facebook')"
              class="border border-gray-300 rounded px-4 py-3 w-1/2 bg-[#1877f2] hover:brightness-95 text-white"
              title="Login met Facebook"
            >
              <img
                class="h-8 mx-auto"
                src="/img/login-facebook.svg"
              >
            </a>
          </div>
        </div>

        <div class="border-b border-gray-200 my-8 text-center w-full leading-[0]">
          <div class="inline bg-white leading-[0] px-3">
            of
          </div>
        </div>

        <div>
          <!-- login -->
          <div class="pb-4 mb-4 border-b border-gray-200">
            <form @submit.prevent="login">
              <p class="font-bold text-lg">
                Bestaande klanten
              </p>

              <div
                v-if="error"
                class="rounded-md bg-red-50 p-4"
              >
                <h3 class="text-sm font-medium text-red-800">
                  Deze combinatie van e-mailadres en wachtwoord is niet geldig.
                </h3>
              </div>

              <div class="mt-1 md:mt-[.625rem] relative rounded-md shadow-sm">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <i class="h-5 w-5 text-gray-300 fa fa-envelope" />
                </div>
                <input
                  v-model="email"
                  type="email"
                  name="email"
                  class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                  placeholder="E-mailadres"
                  required
                >
              </div>

              <div class="mt-1 relative rounded-md shadow-sm">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <i class="h-5 w-5 text-gray-300 fa fa-lock" />
                </div>
                <input
                  v-model="password"
                  type="password"
                  name="password"
                  class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                  placeholder="Wachtwoord"
                  required
                >
              </div>

              <div class="flex mt-2">
                <button
                  type="submit"
                  :disabled="loading"
                  class="justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white sm:col-start-2 sm:text-sm"
                  :class="{'bg-green-500 hover:bg-green-600': !loading, 'bg-gray-500': loading}"
                >
                  <i
                    v-if="loading"
                    class="fa fa-spinner fa-spin mr-2"
                  />
                  Login
                </button>
                <a
                  :href="route('forgot-password')"
                  class="grow text-right py-2 text-sky-400 hover:underline"
                >
                  Wachtwoord vergeten?
                </a>
              </div>
            </form>
          </div>

          <!-- register -->
          <div>
            <form
              :action="route('register')"
              method="get"
            >
              <p class="font-bold text-lg">
                Nieuw bij JouwVeilingen?
              </p>
              <p class="text-xs text-gray-500">
                Door een gratis account op onze website aan te maken kunt u snel en
                gemakkelijk mee bieden in de diverse veilingen die wij dagelijks organiseren!
              </p>
              <div class="mt-1 relative rounded-md shadow-sm">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <i class="h-5 w-5 text-gray-300 fa fa-envelope" />
                </div>
                <input
                  type="email"
                  name="email"
                  class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                  placeholder="E-mailadres"
                  required
                >
              </div>

              <button
                type="submit"
                class="mt-2 inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-500 hover:bg-green-600 text-base font-medium text-white sm:col-start-2 sm:text-sm"
              >
                Registreren
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from '../Mixins/Modal';

const axios = require('axios');

export default {
  mixins: [Modal],

  props: {
    fields: {
      type: Object,
      required: true,
    },
  },

  data () {
    return {
      loading: false,
      email: '',
      password: '',

      error: false,
    };
  },

  methods: {
    login () {
      if (this.loading) {
        return;
      }

      this.loading = true;
      this.error = null;

      let data = this.fields;
      data.email = this.email;
      data.password = this.password;

      axios.post(this.route('ajax.login'), data)
          .then(() => window.location.reload())
          .catch((error) => {
            this.loading = false;
            this.error = 'response' in error ? error.response.data[0] : 'Er is een fout opgetreden, probeer het nogmaals.';
          });
    },
  },
};
</script>
